// extracted by mini-css-extract-plugin
module.exports = {"badgeFilter":"NTag_badgeFilter__28dEE","badgeIcon":"NTag_badgeIcon__2I3gL"};